{
  "dashboard.title": "로열티 대시보드",
  "actionReferralReportDownloadButton.tooltip": "추천 프로그램 리포트는 추천 정보가 포함된 CSV 파일입니다. 다운로드에 수 분이 걸릴 수 있습니다.",
  "actionReferralReportDownloadButton.label": "추천 프로그램 리포트 다운로드",
  "referralRevenueWidget.title": "순수익 및 투자 수익률",
  "referralRevenueWidget.roiTotals.title": "투자 수익률",
  "referralRevenueWidget.roiTotals.titleTooltip": "순수익을 선택한 기간의 투자로 나눈 값.",
  "referralRevenueWidget.investmentTotals.title": "투자",
  "referralRevenueWidget.investmentTotals.titleTooltip": "선택한 기간의 구매에 사용된 추천 상품권의 총 비용.",
  "referralRevenueWidget.revenueTotals.title": "순수익",
  "referralRevenueWidget.revenueTotals.titleTooltip": "선택한 기간 동안 추천 구매로부터 획득한 총 수익에서 모든 할인을 뺀 금액.",
  "referralRevenueWidget.chartMetaData.displayName.revenue": "순수익",
  "referralRevenueWidget.chartMetaData.displayName.investment": "투자",
  "referralRevenueWidget.chartMetaData.displayName.roi": "투자 수익률",
  "referralSucccessWidget.chartMetaData.diaplayName.successRate": "성공률",
  "referralSucccessWidget.successRate.title": "성공률",
  "referralSucccessWidget.successRate.titleTooltip": "선택한 기간 동안 Smart Insights 최근성 설정을 기반으로 구매에 대해 추천된 친구가 상환(사용)한 추천 코드의 퍼센트.",
  "referralSucccessWidget.title": "추천 성공률",
  "referralVouchersWidget.title": "추천 상품권",
  "referralVouchersWidget.redeemedTotal.title": "상환된 상품권",
  "referralVouchersWidget.redeemedTotal.titleTooltip": "추천된 친구가 구매에 사용(상환)한 총 추천 코드 수.",
  "referralVouchersWidget.issuedTotal.title": "발행된 상품권",
  "referralVouchersWidget.issuedTotal.titleTooltip": "추천된 친구에게 Loyalty 멤버가 보낸 총 추천 코드 수.",
  "referralVouchersWidget.chartMetaData.issuedVouchers.displayName": "발행된 바우처",
  "referralVouchersWidget.chartMetaData.redeemedVouchers.displayName": "상환된 상품권",
  "averageOrderValueWidget.title": "평균 오더 금액",
  "averageOrderValueWidget.totals.nonLoyaltyMembers": "비 Loyalty 멤버",
  "averageOrderValueWidget.totals.loyaltyMembers": "Loyalty 멤버",
  "averageOrderValueWidget.totals.uplift": "Loyalty 인상",
  "averageOrderValueWidget.chart.nonLoyaltyMembers": "비 Loyalty 멤버",
  "averageOrderValueWidget.chart.loyaltyMembers": "Loyalty 멤버",
  "dashboardEmptyState.title": " 표시할 데이터가 없습니다.",
  "dashboardEmptyState.lead": "표시할 데이터가 없습니다.",
  "dashboardView.loyaltyImpact.title": "Loyalty 영향",
  "dashboardView.numOfMembersWidget.title": "Loyalty 멤버 증가",
  "dashboardView.engagementRatesWidget.title": "Loyalty 인게이지먼트",
  "dashboardView.pointsAnalyticsWidget.title": "보상 분석",
  "engagementRatesWidget.title": "인게이지먼트 비율",
  "engagementRatesWidget.totalsEngagement.ratePct.title": "Loyalty 인게이지먼트 비율",
  "engagementRatesWidget.totalsRedemption.ratePct.title": "포인트 인게이지먼트 비율",
  "inThePastDays": "지난 {selectedDaysRange}일 동안.",
  "engagementRatesWidget.mainSeries.redemtion.name": "포인트 상환율",
  "engagementRatesWidget.redemptionRateWidget.title": "포인트 상환율",
  "engagementRatesWidget.redemptionRateWidget.titleTooltip": "Smart Insights 최근성 설정을 기반으로, 선택한 기간 동안 보상을 위해 사용(상환)된 총 포인트의 퍼센트.",
  "engagementRatesWidget.engagementRateWidget.titleTooltip": "선택한 기간 동안 구매 및 작업에서 포인트를 누적했거나 보상을 위해 포인트를 사용용(상환)한 회원의 퍼센트.",
  "engagementRatesWidget.engagementRateWidget.title": "Loyalty 인게이지먼트 비율",
  "engagementRatesWidget.chartMetaData.main.displayName": "Loyalty 인게이지먼트 비율",
  "enrollmentsWidget.title": "Loyalty 등록",
  "enrollmentsWidget.totals.leadTotal.title": "등록된 리드",
  "enrollmentsWidget.totals.customerTotal.title": "등록된 멤버",
  "enrollmentsWidget.totals.enrollTotal.title": "총 등록 수",
  "enrollmentsWidget.tooltip.label": "Loyalty 등록",
  "enrollmentsWidget.chartMetaData.customer.displayName": "멤버",
  "enrollmentsWidget.chartMetaData.lead.displayName": "리드",
  "generatedRevenueWidget.title": "Loyalty 멤버 수익",
  "generatedRevenueWidget.widgetCollapsedContentElement.totalRevenue.title": "총 수익",
  "generatedRevenueWidget.widgetCollapsedContentElement.loyaltyRevenue.title": "Loyalty 수익",
  "generatedRevenueWidget.widgetCollapsedContentElement.loyaltyImpactPct.title": "Loyalty 수익 영향",
  "generatedRevenueWidget.chartDataTotalRevenue.name": "총 수익",
  "generatedRevenueWidget.chartDataLoyaltyRevenue.name": "Loyalty 수익",
  "generatedRevenueWidget.totals.loyaltyImpactPct.titleTooltip": "Loyalty 프로그램에서 발생한 총 수익의 퍼센트.",
  "generatedRevenueWidget.totals.loyaltyImpactPct.title": "Loyalty 수익 영향",
  "generatedRevenueWidget.totals.loyaltyActionRevenue.title": "Loyalty 작업 수익",
  "generatedRevenueWidget.totals.loyaltyActionRevenue.titleTooltip": "멤버가 완료한 Loyalty 행동에서 발생한 수익.",
  "generatedRevenueWidget.totals.loyaltyRevenue.title": "총 Loyalty 수익",
  "generatedRevenueWidget.totals.loyaltyRevenue.titleTooltip": "선택한 기간 동안 Loyalty 멤버로부터 발생한 총 수익.",
  "generatedRevenueWidget.totals.totalRevenue.title": "총 수익",
  "generatedRevenueWidget.totals.totalRevenue.titleTooltip": "총 수익에는 선택한 기간 동안의 판매 데이터를 기반으로 모든 구매가 포함됩니다. 또한 총 수익에는 총 수익의 가치를 감소시키는 반품 항목(환불)도 포함됩니다.",
  "generatedRevenueWidget.chartTooltipContent.totalRevenue.label": "총 수익",
  "generatedRevenueWidget.chartTooltipContent.loyaltyRevenue.label": "총 Loyalty 수익",
  "generatedRevenueWidget.chartTooltipContent.totalActionRevenue.label": "Loyalty 작업 수익",
  "generatedRevenueWidget.chartTooltipContent.loyaltyImpactPct.label": "Loyalty 수익 영향",
  "numOfMembersWidget.title": "총 Loyalty 멤버",
  "numOfMembersWidget.total.title": "Loyalty 멤버",
  "numOfMembersWidget.chartTooltipContent.label": "Loyalty 멤버",
  "pointsAnalyticsWidget.title.spend": "크레딧 분석",
  "pointsAnalyticsWidget.title.points": "포인트 분석",
  "pointsAnalyticsWidget.chartMetadata.spend.accumulated.displayName": "누적 크레딧",
  "pointsAnalyticsWidget.chartMetadata.spend.accumulated.totalsTooltip": "선택한 기간 동안 확정된 총 크레딧 수.",
  "pointsAnalyticsWidget.chartMetadata.spend.accumulatedBashback.displayName": "누적 캐시백",
  "pointsAnalyticsWidget.chartMetadata.spend.accumulatedBashback.totalsTooltip": "선택한 기간 동안 확정된 캐시백 총액.",
  "pointsAnalyticsWidget.chartMetadata.spend.pending.displayName": "대기 중인 크레딧",
  "pointsAnalyticsWidget.chartMetadata.spend.pending.totalsTooltip": "선택한 기간 동안 대기 중인 크레딧 총액.",
  "pointsAnalyticsWidget.chartMetadata.spend.expired.displayName": "만료된 크레딧",
  "pointsAnalyticsWidget.chartMetadata.spend.expired.totalsTooltip": "선택한 기간 동안 만료된 총 크레딧 수량.",
  "pointsAnalyticsWidget.chartMetadata.points.accumulated.displayName": "누적 포인트",
  "pointsAnalyticsWidget.chartMetadata.points.accumulated.totalsTooltip": "선택한 기간 동안 확정된 크레딧 총액.",
  "pointsAnalyticsWidget.chartMetadata.points.pending.displayName": "대기 중인 포인트",
  "pointsAnalyticsWidget.chartMetadata.points.pending.totalsTooltip": "선택한 기간 동안 대기 중인 포인트 총액.",
  "pointsAnalyticsWidget.chartMetadata.points.expired.displayName": "만료/제거된 포인트",
  "pointsAnalyticsWidget.chartMetadata.points.expired.totalsTooltip": "선택한 기간 동안 만료/제거된 포인트 총액.",
  "pointsAnalyticsWidget.chartMetadata.points.redeemed.displayName": "상환된 포인트",
  "pointsAnalyticsWidget.chartMetadata.points.redeemed.totalsTooltip": "선택한 기간 동안 사용(상환)된 포인트 총액.",
  "purchaseFrequencyWidget.title": "기간 내 구매 수",
  "purchaseFrequencyWidget.tooltip": "선택한 기간 동안 Smart Insights 최근성 설정을 기반으로 멤버가 구매한 평균 금액.",
  "purchaseFrequencyWidget.totalsMetaData.loyalty.title": "Loyalty 멤버",
  "purchaseFrequencyWidget.totalsMetaData.nonLoyalty.title": "비 Loyalty 멤버",
  "purchaseFrequencyWidget.totalsMetaData.uplift.title": "Loyalty 인상",
  "vouchersAnalyticsWidget.title": "상품권 분석",
  "vouchersAnalyticsWidget.rewardMetaData.displayName": "보상 상품권",
  "vouchersAnalyticsWidget.rewardMetaData.totalsTooltip": "선택한 기간 동안 완료된 작업에 대한 보상과 표시된 상품권 코드에 대한 고정 혜택으로 누적된 상품권 총 수.",
  "vouchersAnalyticsWidget.pointsMetaData.displayName": "포인트용 상품권",
  "vouchersAnalyticsWidget.pointsMetaData.totalsTooltip": "선택한 기간 동안 표시된 상품권 코드에 대한 포인트를 위해 누적된 상품권의 총 수.",
  "vouchersAnalyticsWidget.freeMetaData.displayName": "무료 상품권",
  "vouchersAnalyticsWidget.freeMetaData.totalsTooltip": "선택한 기간 동안 표시된 상품권 코드에 대해 무료로 누적된 상품권의 총 수.",
  "vouchersAnalyticsWidget.cashbackMetaData.displayName": "캐시백용 상품권",
  "vouchersAnalyticsWidget.cashbackMetaData.totalsTooltip": "선택한 기간 동안 표시된 상품권 코드에 대한 캐시백을 위해 누적된 상품권의 총 수.",
  "widgetHelpLink.tooltip": "이 데이터의 계산 방법 보기",
  "viewRange.options.day": "일",
  "viewRange.options.week": "주",
  "viewRange.options.month": "월"
}
